import type { ChangeEntityType, ChangeScopeType, EntityChange, EntityRef } from './_generated';

export interface ScopeRef {
  type: ChangeScopeType;
  id: string;
}

export type Include = 'self' | 'subtree' | ChangeEntityType[];

export interface Watch {
  anchor: ScopeRef;
  include: Include;
}

export const CHANGE_EVENT = 'entity.changed';

export function changeChannel(anchor: ScopeRef): string {
  return `private-changes-${anchor.type}-${anchor.id}`;
}

function isAnchor(ref: EntityRef, anchor: ScopeRef): boolean {
  return ref.type === anchor.type && ref.id === anchor.id;
}

export function matches(change: EntityChange, watch: Watch): boolean {
  const { anchor, include } = watch;
  const changeIsAnchor = isAnchor(change.entity, anchor);

  if (change.action === 'subtree_changed') {
    return changeIsAnchor;
  }
  if (!changeIsAnchor && !change.path.some((ref) => isAnchor(ref, anchor))) {
    return false;
  }
  if (include === 'subtree') {
    return true;
  }
  if (include === 'self') {
    return changeIsAnchor;
  }
  return include.includes(change.entity.type);
}
